import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const payoutApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'payoutApi',
  tagTypes: ['Payout'],
  endpoints: () => ({})
})

export default payoutApi
